import React from "react";
import { useTranslation } from "react-i18next";
import { immunizationsNJPrivacyPdfURL } from "../utils/data";
import { t } from "i18next";

interface TextProps {
  text: string;
  url?: string;
}

interface LinkProps {
  texts: TextProps[];
}

export const paragraphWithLinks = ({ texts }: LinkProps) => {
  return (
    <div>
      {texts.map((text: TextProps, index: number) => {
        return (
          <p key={index} role="paragraph">
            {!text.url && <p>{text.text}</p>}
            {text.url && <a href={text.url}>{text.text}</a>}
          </p>
        );
      })}
    </div>
  );
};

export const utSearchFooter = () => {
  return (
    <div>
      {"Utah:  Docket Health, Inc. (Docket®) is a contractor of the Utah Department of Health and Human Services and " +
        "is prohibited from sharing your personal information or immunization records with third parties. The Utah DHHS does" +
        " not disclose information except as authorized by law. You are not legally required to provided personal information " +
        "to Docket®. However, the information requested is necessary to authorize Docket® to search for and locate personal " +
        "immunization records. Using the Docket® app is not the only way you can access your immunization records. Your " +
        "immunization records can be obtained by requesting them from your healthcare provided or from the Utah DHHS website."}
      <span style={{ fontWeight: "bold" }}>
        {" Please note that your use of the Docket® app to access your immunization " +
          "records is voluntary."}
      </span>
    </div>
  );
};

export const njSearchFooter = () => {
  return (
    <div>
      {"New Jersey: " + t("immunizations.search_records_legal_nj")}
      <a href={immunizationsNJPrivacyPdfURL} target="_blank">
        <span className="is-underlined">{"New Jersey's Privacy Notice."}</span>
      </a>
    </div>
  );
};

export const mnSearchFooter = () => {
  return (
    <div>
      {"Minnesota: " + t("immunizations.search_records_legal_mn")}
      <a href={"https://www.health.state.mn.us/people/immunize/miic/records.html"} target="_blank">
        {" "}
        <span className="is-underlined">{"Minnesota Department of Health"}</span>
      </a>
    </div>
  );
};

export const idSearchFooter = () => {
  return (
    <div>
      {"Idaho: " + t("immunizations.search_records_legal_id")}
      <br />
      <a
        href={"https://healthandwelfare.idaho.gov/news-notices/public-records-requests"}
        target="_blank"
      >
        <span className="is-underlined">{"Records Request"}</span>
      </a>
      <br />
      <a
        href={"https://healthandwelfare.idaho.gov/about-dhw/privacy-and-confidentiality"}
        target="_blank"
      >
        <span className="is-underlined">
          {"Idaho Department of Health and Welfare Privacy Policy"}
        </span>
      </a>
    </div>
  );
};

export const akSearchFooter = () => {
  return (
    <div>
      {"Alaska: " +
        'By selecting "I consent", the user understands that while Docket® is a secure platform, the device used to access Docket® may not be secure. By accessing this service, the user accepts full responsibility (and all liability for) any and all information displayed by, or downloaded from the app/website. Additionally, Docket Health, Inc. recommends that the user establish device access controls (i.e., require a PIN, biometric, or password) to access the device and establish an inactivity screen lock.'}
    </div>
  );
};
